<template>
  <div class="notification">
  	<h1>通知中心</h1>
  	<div>
  		<el-table :data="list" style="width: 100%">
		    <el-table-column type="expand">
		      <template slot-scope="props">
		      	<div class="content">
			        <div v-html="props.row.content"></div>
		      	</div>
		      </template>
		    </el-table-column>
		    <el-table-column label="公告标题" prop="title" />
		    <!-- <el-table-column label="状态">
          <template slot-scope="scope">
          	<el-tag v-if="scope.row.status" type="info">已读</el-tag>
          	<el-tag v-else type="danger">未读</el-tag>
          </template>
        </el-table-column> -->
		    <!-- <el-table-column label="创建者" prop="name" /> -->
		    <el-table-column label="创建时间" prop="createTime" />
		  </el-table>

		  <div class="pagination">
			  <el-pagination
				  background
				  :page-size="pagination.pageSize"
				  :current-page="pagination.currentPage"
				  layout="prev, pager, next"
				  @current-change="currentChange"
				  :total="pagination.total">
				</el-pagination>
		  </div>

  	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    	list: [],
    	pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
  	currentChange (val) {
      this.pagination.currentPage = val
      this.getList()
  	},
    async getList() {
      const { code, data } = await this.request.post('/front/system/config/message/query', {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        })

      if (code == 200) {
        this.list = data.data
        this.pagination.total = data.totalCount
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  // border: 1px solid red;
  width: 95%;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 70px;
  h1 {
  	margin-bottom: 20px;
  }
  .content {
  	margin: 20px 50px;
  }
  .pagination {
  	margin: 20px;
  	float: right;
  }
}
</style>

